import { Component, computed, input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'shared-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.css'],
  imports: [],
})
export class FormErrorComponent {
  errors = input<ValidationErrors | null>(null);

  validationErrors = input<ValidationErrors>();

  keys = computed(() => Object.keys(this.errors() ?? {}));
}
